import React from 'react';
import { validations } from './validations';
import NodeWrapper from './NodeWrapper';
import Analytics from './themes/classic/Analytics';

const CustomInput = (props) => {

  const iconStyle = {
    top: '30%',
    left: '29%',
  }

  return (
    <NodeWrapper type="analytics" data={props?.data != undefined ? props?.data : ''}>
      <Analytics props={props} iconStyle={iconStyle} validations={validations} />
    </NodeWrapper>
  );
};

export default CustomInput;
